<template>
  <div v-if="lastPage > 1" class="mt-5 flex items-center justify-between">
    <div class="text-sm text-gray-600">
      Показано {{ (currentPage - 1) * perPage + 1 }} -
      {{ Math.min(currentPage * perPage, total) }}
      из {{ total }}
    </div>
    <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
      <button
        @click="$emit('change-page', currentPage - 1)"
        :disabled="currentPage === 1"
        class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
        :class="currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''"
      >
        Назад
      </button>
      <template v-for="page in lastPage" :key="page">
        <button
          v-if="page === currentPage ||
                page === 1 ||
                page === lastPage ||
                (page >= currentPage - 1 && page <= currentPage + 1)"
          @click="$emit('change-page', page)"
          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium"
          :class="page === currentPage ? 'bg-blue-50 text-blue-600 z-10' : 'text-gray-500 hover:bg-gray-50'"
        >
          {{ page }}
        </button>
        <span
          v-else-if="page === currentPage - 2 || page === currentPage + 2"
          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
        >
          ...
        </span>
      </template>
      <button
        @click="$emit('change-page', currentPage + 1)"
        :disabled="currentPage === lastPage"
        class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
        :class="currentPage === lastPage ? 'opacity-50 cursor-not-allowed' : ''"
      >
        Вперед
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    }
  }
};
</script>
